import {
  GENERATION_MODEL_QUALITY,
  GENERATION_MODEL_SPEED,
  type GenerationSettings,
} from '../state/useGenerationState';

/**
 * スピード (標準) / 高品質モードの切替ロジック。
 * - 現在の image_size を退避先の localStorage に保存
 * - 切替先の保存済み image_size を復元
 *   (512px は 2026-10-08 に廃止。保存済みの 512px は 1K へ読み替える)
 * - generation_model / image_size を settings に反映
 * - generation_model を localStorage に保存
 *
 * GenerationPreviewPanel のドロップダウン内と HypeAppHomePage で同一ロジックを使うために切り出し。
 */
export function selectImageModel(
  target: 'quality' | 'speed',
  currentSettings: Pick<GenerationSettings, 'image_size'>,
  setSettings: (updater: (prev: GenerationSettings) => GenerationSettings) => void,
): void {
  const currentSize = currentSettings.image_size;

  if (target === 'quality') {
    if (currentSize) {
      localStorage.setItem('image_size_speed', currentSize);
    }
    const savedQualitySize = localStorage.getItem('image_size_quality') || '1K';
    setSettings((prev) => ({
      ...prev,
      generation_model: GENERATION_MODEL_QUALITY,
      image_size: savedQualitySize,
    }));
    localStorage.setItem('generation_model', GENERATION_MODEL_QUALITY);
    return;
  }

  // target === 'speed'
  if (currentSize) {
    localStorage.setItem('image_size_quality', currentSize);
  }
  const savedSpeedSize = localStorage.getItem('image_size_speed');
  const speedSize = !savedSpeedSize || savedSpeedSize === '512px' ? '1K' : savedSpeedSize;
  if (savedSpeedSize === '512px') {
    localStorage.setItem('image_size_speed', speedSize);
  }
  setSettings((prev) => ({
    ...prev,
    generation_model: GENERATION_MODEL_SPEED,
    image_size: speedSize,
  }));
  localStorage.setItem('generation_model', GENERATION_MODEL_SPEED);
}

/**
 * model_code を受け取って selectImageModel にディスパッチする。
 * スピード/高品質以外の将来モデルは generation_model の値だけを素直に差し替える。
 */
export function selectImageModelByCode(
  modelCode: string,
  currentSettings: Pick<GenerationSettings, 'image_size'>,
  setSettings: (updater: (prev: GenerationSettings) => GenerationSettings) => void,
): void {
  if (modelCode === GENERATION_MODEL_QUALITY) {
    selectImageModel('quality', currentSettings, setSettings);
    return;
  }
  if (modelCode === GENERATION_MODEL_SPEED) {
    selectImageModel('speed', currentSettings, setSettings);
    return;
  }
  setSettings((prev) => ({ ...prev, generation_model: modelCode }));
  localStorage.setItem('generation_model', modelCode);
}
